import { __read } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { hookObjectProperty, log } from '@slardar/sdk-template';
import { getDefaultBrowser, getDefaultHistory, getDefaultLocation } from '../../utils';
import { applyOnPidChange, applyOnUrlChange, getDefaultExtractor } from './util';
var PAGEVIEW_EV_TYPE = 'pageview';
export var PageviewMonitor = function (window, location, history) {
    if (window === void 0) { window = getDefaultBrowser(); }
    if (location === void 0) { location = getDefaultLocation(); }
    if (history === void 0) { history = getDefaultHistory(); }
    if (!window || !location) {
        return;
    }
    return function (props, cb) {
        log('[PageviewMonitor] props', props);
        var sendInitFlag = props.sendInit, initPid = props.initPid, routeMode = props.routeMode, extractPid = props.extractPid, onPidUpdate = props.onPidUpdate;
        var restoreFns = [];
        var report = function (source, pid) {
            cb &&
                cb({
                    ev_type: PAGEVIEW_EV_TYPE,
                    payload: {
                        pid: pid,
                        source: source,
                    },
                });
        };
        var extractPidFromUrl = routeMode === 'manual' ? function () { return ''; } : getDefaultExtractor(routeMode);
        var customPidFromUrl = extractPid || (function () { return undefined; });
        var getFinalPid = function (url) { var _a; return (_a = customPidFromUrl(url)) !== null && _a !== void 0 ? _a : extractPidFromUrl(url); };
        var _a = __read(applyOnPidChange(report, initPid || getFinalPid(location.href), extractPidFromUrl(location.href), onPidUpdate), 2), onPidChange = _a[0], sendInit = _a[1];
        var sendPageview = onPidChange.bind(null, "user_set" /* user_set */);
        if (routeMode !== 'manual') {
            var _b = __read(applyOnUrlChange(function (sources, url) {
                return onPidChange(sources, extractPidFromUrl(url), customPidFromUrl(url));
            }, ''), 1), onUrlChange_1 = _b[0];
            var historyChangeListener_1 = function () { return onUrlChange_1("history" /* history */, location.href); };
            if (history) {
                var hookStateChange = function (origin) {
                    return function () {
                        var params = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            params[_i] = arguments[_i];
                        }
                        try {
                            origin.apply(history, params);
                        }
                        finally {
                            historyChangeListener_1();
                        }
                    };
                };
                restoreFns.push(hookObjectProperty(history, 'pushState', hookStateChange)(), hookObjectProperty(history, 'replaceState', hookStateChange)());
            }
            if (routeMode === 'hash') {
                var hashChangeListener_1 = function () { return onUrlChange_1("hash" /* hash */, location.href); };
                window.addEventListener('hashchange', hashChangeListener_1, true);
                restoreFns.push(function () { return window.removeEventListener('hashchange', hashChangeListener_1, true); });
            }
            else {
                window.addEventListener('popstate', historyChangeListener_1, true);
                restoreFns.push(function () { return window.removeEventListener('popstate', historyChangeListener_1, true); });
            }
        }
        var tearDown = function () {
            restoreFns.forEach(function (fn) { return fn(); });
        };
        if (sendInitFlag) {
            log('[PageviewMonitor] send init pid', initPid || location.href);
            sendInit();
        }
        return [sendPageview, tearDown];
    };
};
//# sourceMappingURL=index.js.map